export const SvgDefs = () => (
  <svg style={{ height: 0 }}>
    <defs>
      <linearGradient
        id="paint0_linear_905:2681"
        x1="29.3984"
        y1="11.9465"
        x2="7.02171"
        y2="34.3231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657445" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_905:2681"
        x1="45.4446"
        y1="27.0023"
        x2="13.1819"
        y2="27.0023"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_905:2681"
        x1="33.4342"
        y1="30.0615"
        x2="3.08977"
        y2="60.4059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_905:2681"
        x1="10.062"
        y1="0.569156"
        x2="23.612"
        y2="14.1192"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_905:2681"
        x1="45.4466"
        y1="27.0022"
        x2="13.1844"
        y2="27.0022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CCB300" />
        <stop offset="0.4087" stopColor="#CC9700" />
        <stop offset="0.7754" stopColor="#CC8400" />
        <stop offset="1" stopColor="#CC7D00" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_905:2681"
        x1="33.4348"
        y1="30.0615"
        x2="3.09036"
        y2="60.4059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC2E36" />
        <stop offset="1" stopColor="#9C0E4E" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_905:2681"
        x1="29.3984"
        y1="11.9466"
        x2="7.0217"
        y2="34.3233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008DE0" />
        <stop offset="0.00657445" stopColor="#008DE0" />
        <stop offset="0.2601" stopColor="#00A7E0" />
        <stop offset="0.5122" stopColor="#00B8E0" />
        <stop offset="0.7604" stopColor="#00C4E0" />
        <stop offset="1" stopColor="#00C7E0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_905:2681"
        x1="33.4351"
        y1="30.0618"
        x2="3.09057"
        y2="60.4066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0333C" />
        <stop offset="1" stopColor="#AB0F56" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_905:2681"
        x1="45.4451"
        y1="27.0013"
        x2="13.1824"
        y2="27.0013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0C500" />
        <stop offset="0.4087" stopColor="#E0A600" />
        <stop offset="0.7754" stopColor="#E09100" />
        <stop offset="1" stopColor="#E08900" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_905:2681"
        x1="45.4456"
        y1="27.0013"
        x2="13.183"
        y2="27.0013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE840" />
        <stop offset="0.4087" stopColor="#FFCE40" />
        <stop offset="0.7754" stopColor="#FFBC40" />
        <stop offset="1" stopColor="#FFB540" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_905:2681"
        x1="29.3983"
        y1="11.9467"
        x2="7.0217"
        y2="34.3233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40B8FF" />
        <stop offset="0.00657445" stopColor="#40B9FF" />
        <stop offset="0.2601" stopColor="#40CEFF" />
        <stop offset="0.5122" stopColor="#40DDFF" />
        <stop offset="0.7604" stopColor="#40E7FF" />
        <stop offset="1" stopColor="#40EAFF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_905:2681"
        x1="10.0618"
        y1="0.568674"
        x2="23.6118"
        y2="14.1187"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65B895" />
        <stop offset="0.0685" stopColor="#62BD95" />
        <stop offset="0.4762" stopColor="#50DB97" />
        <stop offset="0.8009" stopColor="#44ED98" />
        <stop offset="1" stopColor="#40F498" />
      </linearGradient>
    </defs>
  </svg>
);
